// extracted by mini-css-extract-plugin
export default {"melodyVideo":"RI-z","isFullWidth":"SI-z","landingPageVideo":"TI-z","play":"UI-z","iframeVideo":"VI-z","playHidden":"WI-z","fullwidth":"XI-z"};